import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IVerificar } from 'src/app/core/models/search';
import { BaseService } from 'src/app/shared/services/base.service';
import { DiplomaSearchService } from 'src/app/shared/services/diploma-search.service';
import { SnackBarService } from 'src/app/shared/services/snack-bar/snack-bar.service';
import { SessionStorageUtils } from 'src/app/shared/utils/session-storage';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  isLoading: boolean = false;
  private sessionStorage = new SessionStorageUtils();
  form: FormGroup;
  isIframe: boolean = false;
  fragment: string | null = null;

  constructor(private router: Router,
              private activatedRouter: ActivatedRoute,
              private searchService: DiplomaSearchService,
              public fb: FormBuilder,
              private snackBar: SnackBarService,
              private baseService: BaseService) {                
    this.form = this.fb.group({
      diplomaNumber: ['', Validators.required]
    })
  }

  ngOnInit(): void {
    this.sessionStorage.onClearSessao();
    this.activatedRouter.queryParams.subscribe((param: any) => 
      (param.codigo || param.token) && this.onVerifyDiploma(Array.isArray(param.codigo) ? param.codigo : [param.codigo], param.token)
    )
    this.onCheckIframe();
    this.activatedRouter.fragment.subscribe(frag => {
      this.fragment = frag;
      this.fragment?.startsWith('/') ? this.fragment = this.fragment.substring(1) : this.fragment;
    });
    
    if (this.fragment) {
      this.onVerifyDiploma([this.fragment]);
      this.form.get('diplomaNumber')?.setValue(this.fragment);
    }
  }

  onVerifyDiploma(codeUrl?: string[], token?: string){    
    const code: string[] = codeUrl ? codeUrl : [this.form.get('diplomaNumber')?.value as string];
    this.isLoading = true;
    this.searchService.onSearchDiploma(code, token).subscribe((data: IVerificar) => {
      this.sessionStorage.onSetDiploma(data.dados);     
      this.sessionStorage.onSetNumberDiploma(code);  
      this.isLoading = false;  
      this.router.navigate(['detalhes']);
    },(error: any) =>{ this.isLoading = false; });
    
  }

  onCheckIframe(){
    this.isIframe = this.baseService.onCheckIframe();
  }

}
